__turbopack_context__.v({
  "input": "phone-module__Fukesq__input",
  "select_container": "phone-module__Fukesq__select_container",
  "select_input": "phone-module__Fukesq__select_input",
  "select_option": "phone-module__Fukesq__select_option",
  "select_options": "phone-module__Fukesq__select_options",
});
